import React, { useState, useRef, useEffect, useContext } from "react";
import styled from "styled-components";
import goTo from "../../../../../controllers/goTo";
import Context from "../../../../../Context";

const TabContainer = styled.div`
  display: flex;
  position: relative;

  border-radius: 999px;
  width: ${({ collapsed }) => (collapsed ? "100%" : "100%")};
  /* width: fit-content; */
  flex-direction: column;
`;

const Tab = styled.div`
  position: relative;
  cursor: pointer;
  font-size: 25px;
  display: flex;
  gap: 12px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  animation: all 0.6s ease-in;
  color: var(--headerElementDim);
  padding: ${({ collapsed }) => (collapsed ? "12px 0" : "20px 0")};
  padding-left: ${({ collapsed }) => (collapsed ? "0" : "18px")};
  padding-right: ${({ collapsed }) => (collapsed ? "0" : "12px")};
  justify-content: ${({ collapsed }) => (collapsed ? "center" : "space-between")};
  gap: ${({ collapsed }) => (collapsed ? "0" : "12px")};
  transition: all 0.3s ease;

  &:hover {
    color: var(--headerAccent);
  }

  @media (max-width: 1300px) {
    padding: 10px 0;
    padding-left: 15px;
  }

  ${({ active }) => {
    if (active) {
      return `
       color: var(--headerAccent);
      `;
    }
  }}
`;

const Icon = styled.div`
  /* height: 25px; */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  /* margin-right: 10px; */
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

const Text = styled.div`
  font-size: 16.5px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ collapsed }) =>
    collapsed
      ? `
    display: none;
  `
      : ""}

  @media (max-width: 1300px) {
    font-size: 11px;
  }
`;

const Pill = styled.div`
  position: absolute;
  right: -10px;
  top: ${({ top }) => `${top}px`};
  height: ${({ height }) => `${height}px`};
  width: 20px;
  background-color: var(--headerAccent);
  border-radius: 999px;
  transition: all 0.3s ease;
  z-index: 0;
  /* filter: blur(20px); */
  transform: scale(0.7);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const Badge = styled.div`
  border-radius: 100px;
  position: static;
  font-size: 13px;
  font-weight: 700;
  padding: 5px 9px;
  background-color: var(--headerAccent);
  color: var(--headerAccentAlt);
  flex-shrink: 0;
  ${({ collapsed }) => (collapsed ? "display:none;" : "")}
`;

const AnimatedNavVertical = ({
  tabs = [],
  activeIndex,
  setActiveIndex,
  collapsed = false,
}) => {
  const { currentRoute } = useContext(Context);
  const [shouldShow, setShouldShow] = useState(false);
  const [pillStyle, setPillStyle] = useState({ left: 0, width: 0 });
  const tabRefs = useRef([]);

  useEffect(() => {
    let currentPath = window.location.pathname;

    if (currentPath === "/") {
      setShouldShow(true);
    } else {
      let shouldShowVal = false;
      let i = 0;
      for (let item of tabs) {
        if (item.link === currentPath) {
          shouldShowVal = true;
          setActiveIndex(i);
        }
        i++;
      }
      setShouldShow(shouldShowVal);
    }
  }, [currentRoute, setActiveIndex, tabs]);

  useEffect(() => {
    const currentTab = tabRefs.current[activeIndex];
    if (currentTab) {
      setPillStyle({
        top: currentTab.offsetTop,
        height: currentTab.offsetHeight,
      });
    }
  }, [activeIndex, tabs]);

  const handleTabClick = (index) => {
    setShouldShow(true);
    setActiveIndex(index);
    goTo(tabs[index].link)();
  };

  return (
    <TabContainer collapsed={collapsed}>
      {shouldShow ? (
        <Pill top={pillStyle.top} height={pillStyle.height} />
      ) : null}

      {tabs.map((item, index) => (
        <Tab
          key={item.label}
          active={index === activeIndex && shouldShow}
          onClick={() => handleTabClick(index)}
          collapsed={collapsed}
          ref={(el) => (tabRefs.current[index] = el)}
        >
          <LeftSection>
            <Icon active={index === activeIndex}>{item.icon}</Icon>
            <Text active={index === activeIndex} collapsed={collapsed}>
              {item.label}
            </Text>
          </LeftSection>
          {item.badgeCount ? <Badge collapsed={collapsed}>{item.badgeCount}</Badge> : null}
        </Tab>
      ))}
    </TabContainer>
  );
};

export default AnimatedNavVertical;
